import { AxiosResponse } from "axios";
import { httpClient } from "./API";
import {
  ChargerSupplyDays,
  SearchChargerSupplyDays,
} from "@/models/chargeSupplyDays";

export const getChargerSupplyDaysListAPI = async (
  search: SearchChargerSupplyDays
): Promise<AxiosResponse<ChargerSupplyDays[]>> => {
  return httpClient.get(
    "/core/internal/calgary/chargerSupplyTransactionsDaily/list",
    {
      params: { ...search },
    }
  );
};

export const getChargerSupplyDaysSummaryAPI = async (
  search: SearchChargerSupplyDays
): Promise<AxiosResponse<ChargerSupplyDays>> => {
  return httpClient.get(
    "/core/internal/calgary/chargerSupplyTransactionsDaily/summary",
    {
      params: { ...search },
    }
  );
};
